import { useLocation } from '@tanstack/react-router'

import { IdentificationUrlKeys } from '../../types'

export function usePersistedEventFilterSearch() {
  const location = useLocation()
  return location?.state?.search
}

const PERSISTED_KEYS = [
  IdentificationUrlKeys.Since,
  IdentificationUrlKeys.Before,
  IdentificationUrlKeys.Period,
  IdentificationUrlKeys.Environment,
]

export function usePersistedEventFilterParams() {
  const search = usePersistedEventFilterSearch()

  if (search == null) {
    return null
  }

  try {
    const url = new URL(`http://fingerprint.com/${search}`)
    const searchParams = url.searchParams

    return Object.fromEntries(
      PERSISTED_KEYS.map((key) => [key, searchParams.get(key) ?? undefined]).filter(([_, value]) => Boolean(value))
    )
  } catch {
    return null
  }
}
